export default __webpack_public_path__ + "static/media/info.ded2ae35.svg";